import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    MarkovStartvectorProps,
    LoadMarkovStartvectorById,
    setMarkovStartvectorEdit,
    setMarkovStartvectorReloadEdit,
    initMarkovStartvector,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

const Edit = ({
    startvectorId = null,
}: MarkovStartvectorProps) => {
    const model = useSelector((state: StoreType) => state.markovModel.modelView)

    const startvector = useSelector((state: StoreType) => state.markovStartvector.startvectorEdit)
    const reloadEdit = useSelector((state: StoreType) => state.markovStartvector.reloadEdit)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setMarkovStartvectorReloadEdit(false))
        setTimeout(() => {
            dispatch(setMarkovStartvectorReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (startvectorId === 0) {
            dispatch(setMarkovStartvectorEdit(initMarkovStartvector))
            reload()
        } else {
            setLoadState(PENDING)
            LoadMarkovStartvectorById(startvectorId, model.id).then((res) => {
                dispatch(setMarkovStartvectorEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!startvector) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{startvector.id ? `${lang.editStartvector} # ${startvector.id}` : lang.addStartvector}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form startvector={startvector} />
                }
                {
                    reloadEdit
                    && <Form startvector={startvector} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
